export function askConfirmation({ title, message, confirmLabel = 'Xác nhận', cancelLabel = 'Quay lại' }) {
  const previousFocus = document.activeElement;
  const dialog = document.createElement('dialog');
  dialog.className = 'confirmation-dialog';
  dialog.setAttribute('aria-labelledby', 'confirmation-title');
  dialog.setAttribute('aria-describedby', 'confirmation-message');
  dialog.innerHTML = '<form method="dialog" class="stack"><h2 id="confirmation-title"></h2><p id="confirmation-message"></p><div class="button-row"><button value="cancel" class="secondary" autofocus></button><button value="confirm" class="danger"></button></div></form>';
  dialog.querySelector('h2').textContent = title;
  dialog.querySelector('p').textContent = message;
  dialog.querySelector('[value="cancel"]').textContent = cancelLabel;
  dialog.querySelector('[value="confirm"]').textContent = confirmLabel;
  return new Promise(resolve => {
    dialog.addEventListener('close', () => {
      const confirmed = dialog.returnValue === 'confirm';
      dialog.remove();
      if (previousFocus?.isConnected) previousFocus.focus();
      resolve(confirmed);
    }, { once: true });
    document.body.append(dialog);
    dialog.showModal();
  });
}

export function askText(label, initialValue = '') {
  const previousFocus = document.activeElement;
  const dialog = document.createElement('dialog');
  dialog.innerHTML = '<form method="dialog" class="stack"><label><span></span><input name="value" required></label><div class="button-row"><button value="save"><svg class="action-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" style="vertical-align:middle;pointer-events:none;flex-shrink:0"><path d="M5 3h12l4 4v14H3V3h2Zm2 0v6h10V3M7 21v-8h10v8"/></svg> Lưu</button><button type="button" class="secondary" data-cancel>Hủy</button></div></form>';
  dialog.querySelector('span').textContent = label;
  const input = dialog.querySelector('input');
  input.value = initialValue;
  input.maxLength = 120;
  if (label.includes('PIN')) {
    input.type = 'password'; input.inputMode = 'numeric'; input.pattern = '[0-9]{6}'; input.minLength = 6; input.maxLength = 6; input.autocomplete = 'new-password';
  }
  dialog.querySelector('[data-cancel]').addEventListener('click', () => dialog.close('cancel'));
  document.body.append(dialog); dialog.showModal(); input.focus(); input.select();
  return new Promise(resolve => dialog.addEventListener('close', () => {
    const value = dialog.returnValue === 'save' ? input.value.trim() : null;
    dialog.remove(); if (previousFocus?.isConnected) previousFocus.focus(); resolve(value);
  }, { once: true }));
}
